var map = {
	"./lang-cs.png": 9272,
	"./lang-en.png": 5143,
	"./lang-fr.png": 1382,
	"./lang-hu.png": 4583,
	"./lang-lv.png": 240,
	"./lang-nl.png": 4944,
	"./lang-pl.png": 398,
	"./lang-ro.png": 9999,
	"./lang-sr.png": 6321,
	"./lang-ua.png": 7840
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 843;